<template>
  <b-row class="match-height">
    <b-col lg="12">
      <b-card title="Item Disposal">
        <b-form
@keyup.enter.prevent=""
@submit.prevent="submitNewItemDisposal"
>
          <b-row>
            <b-col cols="12">
              <b-button
                type="button"
                variant="primary"
                class="mr-1"
                @click="previous()"
              >
                <feather-icon
                  icon="ArrowLeftIcon"
                  size="16"
                  class="align-middle"
                />
                Back
              </b-button>
              <br>
              <b-form-group
                label="Notes"
                label-for="item_disposal_notes"
                label-cols-md="12"
              >
                <b-form-input
                  id="item_disposal_notes"
                  v-model="itemDisposalNotes"
                  placeholder="Notes"
                />
              </b-form-group>
              <b-form-group
label="Items *"
label-for="chosenItem"
>
                <Select2
v-model="chosenItem"
:settings="settings"
@select="putItem($event)"
/>
              </b-form-group>
              <b-row>
                <b-col
cols="8"
class="text-center font-weight-bold"
>
                  Item name
                </b-col>
                <b-col
cols="2"
class="text-center font-weight-bold"
>
                  Item QTY
                </b-col>
                <b-col
cols="2"
class="text-center font-weight-bold"
>
                  Actions
                </b-col>
              </b-row>
              <p />
              <b-row
v-for="chosen in chosens"
:key="chosen.value"
>
                <br>
                <b-col cols="8 text-center">
                  <b-list-group>
                    <b-list-group-item href="#">
                      {{ chosen.label }}
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
                <b-col cols="2 text-center">
                  <b-form-input
                    v-model="chosen.qty"
                    type="number"
                    placeholder="Qty"
                    min="1"
                    required="required"
                  />
                </b-col>
                <b-col cols="2 text-center">
                  <b-button
                    size="sm"
                    type="button"
                    variant="danger"
                    class="mr-1"
                    @click="removeRow(chosen.value)"
                  >
                    <feather-icon
icon="TrashIcon"
size="18"
/>
                  </b-button>
                </b-col>
                <b-col cols="12">
                  <br>
                </b-col>
              </b-row>
            </b-col>
            <!-- submit and reset -->
            <b-col offset-md="12">
              <b-button
                type="submit"
                variant="primary"
                class="mr-1"
                :disabled="submitButtonDisabled"
              >
                Submit
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BListGroup,
  BListGroupItem,
  BFormFile,
} from "bootstrap-vue"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import axios from "axios"
import moment from "moment-timezone"
import Ripple from "vue-ripple-directive"
import Select2 from 'v-select2-component'

import { ref } from "@vue/composition-api"
import apiEndpoints from '@/constants/apiEndpoints'

const VersionCheck = ""
const items = []
const chosenItem = ref(3)
const chosens = []
const itemDisposalNotes = ""
const itemDisposalCc = ""
const itemDisposalReason = ""
const itemDisposalQtyRequested = 0
const itemDisposalStatus = ""
const submitButtonDisabled = false
export default {
  components: {
    BFormFile,
    BListGroup,
    BListGroupItem,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    Select2,
  },
  directives: {
    Ripple,
  },
  data() {
    const userToken = this.$cookies.get("userToken")
    const branchId = this.$cookies.get("userData").user_branch_id
    return {
      VersionCheck,
      items,
      chosenItem,
      chosens,
      itemDisposalNotes,
      itemDisposalCc,
      itemDisposalReason,
      itemDisposalQtyRequested,
      itemDisposalStatus,
      readonly: false,
      submitButtonDisabled,
      settings: {
        ajax: {
          url: `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_ITEM_STOCKS}`,
          beforeSend: xhr => {
            xhr.setRequestHeader('Authorization', `Bearer ${userToken}`)
          },
          data: params => {
            const query = {
              branchId,
              search: params.term,
              offset: 0,
              limit: 50,
            }

            // Query parameters will be ?search=[term]&type=public
            return query
          },
          processResults: response => {
            let resItems = response.data
            resItems = resItems.map(item => {
              item.text = `${item.item.item_code} - ${item.item.item_name}`
              item.item_id = item.item.item_id
              item.value = item.item_stock_id
              item.id = item.item_stock_id
              item.unitname = item.item.$attrsunit ? item.item.unit.unit_name : '-'
              return item
            })
            // Transforms the top-level key of the response object from 'items' to 'results'
            return {
              results: resItems,
            }
          },
        },
      },
    }
  },
  created() {
    window.setInterval(() => {
      this.removeReadOnly()
    }, 1000)
  },
  async mounted() {
    // await this.getItems()
    this.chosens = []
  },
  methods: {
    removeReadOnly() {
      const searches = document.getElementsByClassName("vs__search")
      for (let i = 0; i < searches.length; i += 1) {
        searches[i].removeAttribute("readonly")
      }
    },
    getItems(search = "") {
      const userToken = this.$cookies.get("userToken")
    const branchId = this.$cookies.get("userData").user_branch_id
const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${userToken}`,
}
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_ITEM_STOCKS}?branchId=${branchId}&offset=0&limit=50search=${search}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            const itemsJoin = response.data.data.map(elem => ({
              text: `${elem.item.item_code} - ${elem.item.item_name}`,
              value: elem.item_stock_id,
              item_id: elem.item.item_id,
              id: elem.item_stock_id,
            }))
            this.items = itemsJoin
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Get Data Success",
                icon: "CheckIcon",
                variant: "success",
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Get Data Failed",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
        .catch(e => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Get Settings Failed",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          })
        })
    },
    submitNewItemDisposal() {
      this.submitButtonDisabled = true
      this.chosens.map(elem => {
        this.itemDisposalQtyRequested += parseInt(elem.qty)
      })
      const body = {
        item_disposal_notes: this.itemDisposalNotes,
        item_disposal_items: JSON.stringify(this.chosens),
        time: moment(),
      }
      if (this.chosens.length > 0) {
        const userToken = this.$cookies.get("userToken")
const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${userToken}`,
}
        axios
          .post(
            `${process.env.VUE_APP_API_URL}${apiEndpoints.API_CREATE_ITEM_DISPOSALS}`,
            body,
            { headers },
          )
          .then(response => {
            if (response.data.success === true) {
              this.chosens = []
              this.itemDisposalQtyRequested = 0
              this.itemDisposalReason = ""
              this.itemDisposalCc = ""
              this.itemDisposalNotes = ""
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Item Disposal Success",
                  icon: "CheckIcon",
                  variant: "success",
                },
              })
              this.$router.replace({ name: "apps-item-disposals-list" })
            } else {
              this.submitButtonDisabled = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Item Disposal Failed",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              })
            }
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Item Disposal Failed",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          })
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "You have to choose at least one item",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        })
      }
    },
    getOptionLabel(option) {
      return (option && option.label) || ""
    },
    putItem(
      {
        id, text, unitname, item_id,
      },
    ) {
      if (this.chosens.length > 0) {
        const item = {
          label: text,
          value: id,
          item_id,
          unitname,
          qty: 1,
          id: this.chosens.length + 1,
          shelf: "",
        }
        this.chosens.push(item)
        // }
      } else {
        const item = {
          label: text,
          value: id,
          item_id,
          unitname,
          qty: 1,
          id: this.chosens.length,
          shelf: "",
        }

        this.chosens.push(item)
      }
    },
    applyItem(val) {

    },
    getOptionKey(option) {
      return (option && option.value) || ""
    },
    inputSearch(search) {

    },
    removeRow(val) {
      this.chosens = this.chosens.filter(obj => obj.value !== val)
    },
    dateFormat(value, format = "MM/DD/YYYY") {
      return moment.utc(value).tz('Asia/Jakarta').format(format)
    },
    previous() {
      this.$router.push({ name: "apps-item-disposals-list" })
    },
    capitalizeWords(str) {
    // Split the string into words using spaces as the separator
    const words = str.split(' ')
    // Capitalize the first letter of each word and join them back together
    const capitalizedWords = words.map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1)
    })
    // Join the capitalized words into a single string with spaces
    return capitalizedWords.join(' ')
    },
  },
}
</script>
